var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m975.48 693.35c-0.42969 0.43359-0.86328 0.87109-1.2969 1.3047-135.05 135.05-357.5 129.45-485.3-16.82-107.65-123.21-108.33-310.1-1.582-434.1 5.875-6.8242 11.957-13.348 18.223-19.566 29.301-29.078-1.4648-77.336-40.586-64.152-70.352 23.707-136.03 65.176-190.05 124.43-161.55 177.2-155.02 454.62 14.223 624.49 176.86 177.52 464.13 177.71 641.24 0.60938 51.652-51.652 88.211-112.68 109.69-177.6 12.887-38.953-35.711-67.762-64.562-38.598z",
    fill: "#01447a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.d00482e0c1a78c3a78ab5319bcb1537a.svg";
export { ForwardRef as ReactComponent };